import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { UpdateTaricNomenclatureCommand } from '@e-origin/contracts';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAdminImportNomenclatures = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: UpdateTaricNomenclatureCommand) => {
      const formData = new FormData();
      formData.append('file', payload.file);
      formData.append('lang', payload.lang);

      return apiClient.nomenclature.updateTaricNomenclature.mutation({
        body: formData,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-catalogs-info'] });
      toast.success('Nomenclatures imported successfully');
    },
    onError: (error: unknown) => {
      showErrorToast(error, 'Failed to import nomenclatures');
    },
  });
};
